// extracted by mini-css-extract-plugin
export default {"wrapper":"Row_wrapper__QQCT9","indent":"Row_indent__ma8AB","header":"Row_header__Ax7Qy","content":"Row_content__fI4Y6"};